const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Siempre más Música',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Presencia en transmisión en vivo por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con música, cultura y entretenimiento en antena',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de audio, bebidas, eventos, moda urbana y lifestyle cultural.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Siempre más Música',
    highlightedTitle: 'Ritmo multiplataforma',
    highlightedContent: [
      'Tu marca viaja con la credibilidad de Arlene Flores y la escena musical TNO.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Música, entrevistas y eventos en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Lanzamientos, Entrevistas, Festivales o Tendencias',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Sellos, festivales, marcas de instrumentos y promotores de eventos.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad en cultura musical',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con artistas y comunidad activa.',
      'Ideal para lanzamientos y activaciones culturales.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de sedes, fechas o puntos de contacto',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Artistas, managers, sellos y voceros de marcas de entretenimiento.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Mención de oferta con respaldo en pantalla.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de Siempre más Música y TNO Digest',
      'Contenido adaptado a música y entretenimiento',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para lanzamientos o reforzar una campaña.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula Musical / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: lanzamiento, evento o promoción musical',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de conciertos, singles, festivales o productos de lifestyle.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de Siempre más Música.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Música y Eventos',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video estilo backstage, fan experience o testimonio con el producto',
      'Demostración en contexto de concierto, ensayo o consumo',
      'Narrativa humana alineada con cultura y entretenimiento',
      'Publicación del video en TNO y en Siempre más Música',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de audio, bebidas, moda y experiencias en vivo.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social en cultura pop',
    highlightedContent: [
      'Contenido UGC con tono del programa y credibilidad de la ancla.',
      'Tu marca como recomendación de un aliado, no como anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
